import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({name: 'tolocaldate'})
export class toLocalDatePipe implements PipeTransform {
  transform(value: any, term: string): any {
    return moment.utc(value).local().format('MMM DD, YYYY h:mm a');
  } 
}